export const COMMON_ACTION_START = 'COMMON_ACTION_START';
export const COMMON_ACTION_SUCCESS = 'COMMON_ACTION_SUCCESS';
export const COMMON_ACTION_ERROR = 'COMMON_ACTION_ERROR';
export const COMMON_REDUCER_CLEAR_ERROR = 'COMMON_REDUCER_CLEAR_ERROR';
export const COMMON_REDUCER_CLEAR_DATA = 'COMMON_REDUCER_CLEAR_DATA';

export const FETCH_PAYMENT_RECEIPT_SUCCESS = 'FETCH_PAYMENT_RECEIPT_SUCCESS';

export const DOWNLOAD_PAYMENT_RECEIPT_SUCCESS = 'DOWNLOAD_PAYMENT_RECEIPT_SUCCESS';

export const CLEAR_PAYMENT_RECEIPT_ERROR = 'CLEAR_PAYMENT_RECEIPT_ERROR';

export const DOCUMENT_VIEW_POPUP = 'DOCUMENT_VIEW_POPUP';
export const DOCUMENT_VIEW_POPUP_SUCCESS = 'DOCUMENT_VIEW_POPUP_SUCCESS';
export const DOCUMENT_VIEW_POPUP_ERROR = 'DOCUMENT_VIEW_POPUP_ERROR';
export const HAPPINESS_METER_FEEDBACK = 'HAPPINESS_METER_FEEDBACK';
export const HAPPINESS_METER_FEEDBACK_SUCCESS = 'HAPPINESS_METER_FEEDBACK_SUCCESS';
export const HAPPINESS_METER_FEEDBACK_ERROR = 'HAPPINESS_METER_FEEDBACK_ERROR';
export const HAPPINESS_METER_UPDATE_FLAG = 'HAPPINESS_METER_UPDATE_FLAG';

// Entity Constants
export const FETCH_ENTITY_SUCCESS = 'FETCH_ENTITY_SUCCESS';
export const RESET_FETCHED_ENTITY_DATA = 'RESET_FETCHED_ENTITY_DATA';
export const UPDATE_ENTITY_CUSTOM_DATA = 'UPDATE_ENTITY_CUSTOM_DATA';
export const UPDATE_USERS_DATA_IN_DB_TABLE_SUCCESS = 'UPDATE_USERS_DATA_IN_DB_TABLE_SUCCESS';
export const ETISALAT_SUBMIT_SUCCESS = 'ETISALAT_SUBMIT_SUCCESS';
export const ETISALAT_SUBMIT_ERROR = 'ETISALAT_SUBMIT_ERROR';
export const ETISALAT_SUBMIT_START = 'ETISALAT_SUBMIT_START';
